// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 952 ? "TemplateManagement" : chunkId) + "." + {"63":"02871728","399":"341b4b77","538":"bd07f469","755":"02871728","952":"7ffacfa9"}[chunkId] + ".chunk.css";
};